<template>
    <div>
        <footer class="mozarella1">
        <img :src="require(`../assets/img/logo/orange/${data.logo}`)" :alt="navBar.name" height="60" width="187">
        </footer>

        <div id="footer-button">
         <a :href="data.buttonURL" id="float-apply" @click="addDataLayer()"><div class="custom-button custom-button--orange">{{  data.buttonText }}</div></a>
        </div>
    </div>
</template>

<script>
  import Content from "../data/content";
  let lang = process.env.VUE_APP_LOCALITY;

  export default {
    name: "Navbar",
    mounted() {
      window.addEventListener('scroll', () => this.showFooterButtons());
    },
    data: function() {
      return {
        data: Content[lang].footer,
        navBar: Content[lang].navbar,
      }
    },
    methods: {
      showFooterButtons() {
        let backToTop = document.getElementById('backTop');
        let firstButton = document.getElementById('first-apply');
        let footbutton = document.getElementById('footer-button');

        if (window.scrollY >= 240) {
          backToTop.style.display = 'block';
        } else {
          backToTop.style.display = '';
        }

        if (window.scrollY > (firstButton.offsetTop + 60)) {
          footbutton.classList.add('show');
        } else {
          footbutton.classList.remove('show');
        }
      },
      async addDataLayer() {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          "event": "apply_submit",
          "component_type": "button",
          "component_name": "apply now",
          "component_location": "Floating"
        });
      }
    }
  }
</script>

<style>
footer {
  padding: 50px 0;
}

.footer-image {
  background: #FAFAFA;
}

footer img {
  max-height: 60px;
  margin: 0 auto;
  display: block;
}

#footer-button {
  background: white;
  padding: 12px 16px;
  position: fixed;
  bottom: 0;
  z-index: 1000;
  left: 0;
  width: 100%;
  transform: translateY(100%);
  transition: all 0.25s ease-in-out;
  display: none;
}

#footer-button .custom-button {
  margin: 0 auto;
}

@media only screen and (max-width: 768px) {
  footer {
    padding-bottom: 100px;
  }
  #footer-button.show {
    transform: translateY(0);
  }  

  #footer-button {
    display: block;
  }

  .backTop {
    display: none !important;
  }
}

.backTop {
  z-index: 988;
  position: fixed;
  bottom: 20px;
  right: 0.83333rem;

  display: none;
  appearance: none;

  height: 3.5rem;
  width: 3.5rem;
  background: none;
  background-color: #fff;
  border: 1px solid #fff;
  border-radius: 50%;
  cursor: pointer;

  box-shadow: 0 2px 4px 0 rgb(29 33 55 / 12%), 0 2px 4px 0 rgb(29 33 55 / 14%), 0 2px 4px 0 rgb(29 33 55 / 12%);

  padding: 0;
  color: #125fca;
  font: inherit;

  user-select: none;

  transition: border-color .15s cubic-bezier(0,0,.3,1) 0s,background-color .15s cubic-bezier(0,0,.3,1) 0s,color .15s cubic-bezier(0,0,.3,1) 0s;
  animation: 0.7s ease-out 0s 1 bounceInUp forwards;
}
.backTop:hover {
  border: 1px solid #125FCA;
}
.backTop:after {
  content: "";
  position: absolute;
  z-index: 989;
  opacity: 1;
  width: .7em;
  height: .7em;
  left: calc(50% - 0.4em);
  top: calc(50% - 0.2em);
  transition: 0.3s;
  margin-right: 0px;
  margin-bottom: 0px;
  border-right: 3px solid #125FCA;
  border-top: 3px solid #125FCA;
  transform: rotate(-45deg);
}

@keyframes bounceInUp {
  0% {
    opacity: 0;
    -webkit-transform: translateY(2000px);
    -ms-transform: translateY(2000px);
    transform: translateY(2000px);
  }
  60% {
    opacity: 1;
    -webkit-transform: translateY(-30px);
    -ms-transform: translateY(-30px);
    transform: translateY(-30px);
  }
  80% {
    -webkit-transform: translateY(10px);
    -ms-transform: translateY(10px);
    transform: translateY(10px);
  }
  100% {
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
    transform: translateY(0);
  }
}
</style>